import { render, staticRenderFns } from "./InvitacionesDashboardView.vue?vue&type=template&id=7136859a"
import script from "./InvitacionesDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesDashboardView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports